import { CommonModule } from '@angular/common';
import { Component, Inject, NgModule, Optional } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';

import { Observable, of } from 'rxjs';

export interface SampleReviewDialogData {
  availableAnalysts: Observable<AnalystDetail[]>;
  sampleId: string;
  currUser: AnalystDetail;
  aiAnalysisInProgressWarning?: boolean;
}

export interface AnalystDetail {
  name: string;
  type: string;
  id: string;
}
@Component({
    selector: 'ts-sample-review-dialog',
    templateUrl: './sample-review-dialog.component.html',
    styleUrls: ['./sample-review-dialog.component.scss'],
    standalone: false
})
export class SampleReviewDialogComponent {
  public selectedAnalyst?: AnalystDetail;

  constructor(
    @Optional() public dialogRef: MatDialogRef<SampleReviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: SampleReviewDialogData = {
      availableAnalysts: of([]),
      sampleId: undefined,
      currUser: undefined,
    }
  ) {}

  accept() {
    this.dialogRef.close(this.selectedAnalyst);
  }

  confirm() {
    return this.accept();
  }

  cancel() {
    this.dialogRef?.close('cancel');
  }

  availableAnalysts(analysts: AnalystDetail[], type: string) {
    return analysts?.some((an) => an.type === type) ?? false;
  }
}

@NgModule({
  imports: [CommonModule, TranslateModule, MatDialogModule, MatProgressBarModule, MatRadioModule, FormsModule],
  declarations: [SampleReviewDialogComponent],
  exports: [SampleReviewDialogComponent],
})
export class SampleReviewDialogComponentModule {}
